import React from 'react';
import styled from 'styled-components';
import * as flightDirections from 'state/checkoutPage/flightsDetails/constants/flightDirections';
import { FormattedMessage } from 'i18n';
import FlightDetails from './components/flightDetails/FlightDetailsComponent';
import Layover from './components/layover/LayoverComponent';
import { mediaQueries } from 'styles/utils/mediaQueries';
import OvernightIcon from 'components/dataPresentation/OvernightIcon/OvernightIcon';
import LuggageInfo from './components/luggageInfo/LuggageInfo';

function LegDetailsComponent({
  departureDate,
  travelTime,
  nonstop,
  segments,
  arrivalAndDepartureAirportAreNotTheSame,
  initialAndLastAirportAreNotTheSame,
  index,
  flightDetails,
  airlineWhitelabel,
  isOvernight,
}) {
  return (
    <Root>
      <LegHeader firstLeg={index === 0}>
        <FlightDate airlineWhitelabel={airlineWhitelabel}>
          <FormattedMessage
            id={index === 0 ? 'leave.label' : 'return.label'}
            description={index === 0 ? flightDirections.LEAVE : flightDirections.RETURN}
            defaultMessage={index === 0 ? flightDirections.LEAVE : flightDirections.RETURN}
          />
          &nbsp;&nbsp;-&nbsp;&nbsp;
          {departureDate}
        </FlightDate>
        <TripTime>
          <FormattedMessage
            id={'totalTripTime.label'}
            description={'Total trip time: {value}'}
            defaultMessage={'Total trip time: {value}'}
            values={{ value: travelTime }}
          />
          {isOvernight && (
            <ReferencesWrap>
              <Reference>
                <OvernightIcon highlighted isOvernight={isOvernight} />
                <ReferenceMessage>
                  <FormattedMessage
                    id='flightIsOverNight'
                    description='Overnight flight'
                    defaultMessage='Overnight flight'
                  />
                </ReferenceMessage>
              </Reference>
            </ReferencesWrap>
          )}
        </TripTime>
      </LegHeader>
      <Segments firstLeg={index === 0} secondLeg={index === 1}>
        {segments.map(({ layoverTime, ...flight }, flightIndex) =>
          layoverTime ? (
            <Layover key={`leg-${index}-layover`} layoverTime={layoverTime} airlineWhitelabel={airlineWhitelabel} />
          ) : (
            <FlightDetails
              key={`leg-${index}-flight-${flightIndex}`}
              {...flight}
              flightDetails={flightDetails}
              legIsNonstop={nonstop}
              firstFlight={flightIndex === 0}
              lastFlight={flightIndex === segments.length - 1}
              arrivalAndDepartureAirportAreNotTheSame={arrivalAndDepartureAirportAreNotTheSame}
              initialAndLastAirportAreNotTheSame={initialAndLastAirportAreNotTheSame}
              airlineWhitelabel={airlineWhitelabel}
              hasLayoverAfter={segments[flightIndex + 1] && segments[flightIndex + 1].layoverTime}
              hasLayoverBefore={segments[flightIndex - 1] && segments[flightIndex - 1].layoverTime}
            />
          )
        )}
      </Segments>
      <LuggageInfo segments={segments} firstLeg={index === 0} />
    </Root>
  );
}

export default LegDetailsComponent;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  &:first-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.background.greyV3};
  }

  ${mediaQueries.fromAndAbove.desktop`
    &:first-child {
      border-bottom: none;
      border-right: 1px solid ${({ theme }) => theme.colors.background.greyV3};
    }
  `}
`;

const LegHeader = styled.div`
  padding: 20px;

  ${mediaQueries.fromAndAbove.desktop`
    padding-left: ${({ firstLeg }) => firstLeg && '40px'};
    border-bottom: 1px solid ${({ theme }) => theme.colors.background.greyV3};
  `}
`;

const FlightDate = styled.div`
  margin-bottom: 8px;
  font-size: 1.8em;
  font-weight: ${({ airlineWhitelabel }) => (airlineWhitelabel && airlineWhitelabel.isAirBaltic ? 500 : 700)};
  color: ${({ theme }) => theme.colors.text.default};
`;

const TripTime = styled.div`
  font-size: 1.4em;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Segments = styled.div`
  flex: 1;
  ${mediaQueries.fromAndAbove.desktop`
    padding-left: ${({ firstLeg }) => firstLeg && '20px'};
    padding-right: ${({ secondLeg }) => secondLeg && '20px'};
  `};
`;
const ReferencesWrap = styled.div`
  max-height: 14px;
`;

const Reference = styled.div`
  display: flex;
  align-items: center;
`;

const ReferenceMessage = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.adjacent.default};
`;
